/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Legend_Cycle_HintInputs */



/**
* | output |
* | --- |
* | "Click a cell to cycle: inherited → granted → denied." |
*
* @param {Rights_Legend_Cycle_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_legend_cycle_hint = /** @type {((inputs?: Rights_Legend_Cycle_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Legend_Cycle_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zelle anklicken zum Wechseln: geerbt → gewährt → verweigert.")
	return /** @type {LocalizedString} */ ("Click a cell to cycle: inherited → granted → denied.")
});